import { render, staticRenderFns } from "./ItemCharm.vue?vue&type=template&id=16c418a2&scoped=true&"
import script from "./ItemCharm.vue?vue&type=script&lang=js&"
export * from "./ItemCharm.vue?vue&type=script&lang=js&"
import style0 from "./ItemCharm.vue?vue&type=style&index=0&id=16c418a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c418a2",
  null
  
)

export default component.exports